import script from "./svgIcon.vue?vue&type=script&setup=true&name=svgIcon&lang=js"
export * from "./svgIcon.vue?vue&type=script&setup=true&name=svgIcon&lang=js"

import "./svgIcon.vue?vue&type=style&index=0&id=54842a68&scope=true&lang=scss"

const __exports__ = script;

export default __exports__